import { fetchApi } from "../api";

export const login = ({ email, password }) =>
  fetchApi("/login_check", {
    body: JSON.stringify({ email, password }),
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  });
